import abhishekChandraImage from '@/images/cee-meetup-2026-private-dinner/abhishek-chandra.svg';
import anaOpritaImage from '@/images/cee-meetup-2026-private-dinner/ana-oprita.svg';
import bogdanDogaruImage from '@/images/cee-meetup-2026-private-dinner/bogdan-dogaru.svg';
import bogdanShkarupaImage from '@/images/cee-meetup-2026-private-dinner/bogdan-shkarupa.png';
import carlottaZorziChapmanImage from '@/images/cee-meetup-2026-private-dinner/carlotta-zorzi-chapman.svg';
import catalinCiochinaImage from '@/images/cee-meetup-2026-private-dinner/catalin-ciochina.svg';
import stelutaSticiImage from '@/images/cee-meetup-2026-private-dinner/steluta-stici.png';
import danNistorImage from '@/images/cee-meetup-2026-private-dinner/dan-nistor.svg';
import davidSimaImage from '@/images/cee-meetup-2026-private-dinner/david-sima.svg';
import graceRadleyImage from '@/images/cee-meetup-2026-private-dinner/grace-radley.svg';
import ilieMihalacheImage from '@/images/cee-meetup-2026-private-dinner/ilie-mihalache.svg';
import paulApostuImage from '@/images/cee-meetup-2026-private-dinner/paul-apostu.svg';
import prakharShrivastavaImage from '@/images/cee-meetup-2026-private-dinner/prakhar-shrivastava.svg';
import raresBanescuImage from '@/images/cee-meetup-2026-private-dinner/rares-banescu.svg';
import stefanChiriacescuImage from '@/images/cee-meetup-2026-private-dinner/stefan-chiriacescu.svg';
import thanasisPsychogiosImage from '@/images/cee-meetup-2026-private-dinner/thanasis-psychogios.svg';
import tudorGoiceaImage from '@/images/cee-meetup-2026-private-dinner/tudor-goicea.svg';
import yaelWeissImage from '@/images/cee-meetup-2026-private-dinner/yael-weiss.svg';
import aquarateLogo from '@/images/cee-meetup-2026/aquarate.svg';
import axonLogo from '@/images/cee-meetup-2026/axon.svg';
import businessLeagueLogo from '@/images/cee-meetup-2026/business_league_logo.webp';
import dataRevoltLogo from '@/images/cee-meetup-2026/data_revolt.svg';
import easySalesLogo from '@/images/cee-meetup-2026/easy_sales.svg';
import foxSellLogo from '@/images/cee-meetup-2026/fox_sell.svg';
import fulfiloLogo from '@/images/cee-meetup-2026/fulfilo.svg';
import gokwikLogo from '@/images/cee-meetup-2026/gokwik.svg';
import kleverLogo from '@/images/cee-meetup-2026/klever.svg';
import lastYearPhotoOne from '@/images/cee-meetup-2026/last_year_photos/last_year_1.webp';
import lastYearPhotoTwo from '@/images/cee-meetup-2026/last_year_photos/last_year_2.webp';
import lastYearPhotoThree from '@/images/cee-meetup-2026/last_year_photos/last_year_3.webp';
import lastYearPhotoFour from '@/images/cee-meetup-2026/last_year_photos/last_year_4.webp';
import lastYearPhotoFive from '@/images/cee-meetup-2026/last_year_photos/last_year_5.webp';
import lastYearPhotoSix from '@/images/cee-meetup-2026/last_year_photos/last_year_6.webp';
import lastYearPhotoSeven from '@/images/cee-meetup-2026/last_year_photos/last_year_7.webp';
import lastYearPhotoEight from '@/images/cee-meetup-2026/last_year_photos/last_year_8.webp';
import locationPhotoOne from '@/images/cee-meetup-2026/location/grand_hotel_1.webp';
import locationPhotoTwo from '@/images/cee-meetup-2026/location/grand_hotel_2.webp';
import locationPhotoThree from '@/images/cee-meetup-2026/location/grand_hotel_3.webp';
import loveLoyaltyLogo from '@/images/cee-meetup-2026/love_loyalty.svg';
import mejixLogo from '@/images/cee-meetup-2026/mejix.svg';
import mollieLogo from '@/images/cee-meetup-2026/mollie.svg';
import neuCurrentLogo from '@/images/cee-meetup-2026/neu_current.svg';
import skroutzLogo from '@/images/cee-meetup-2026/skroutz.svg';
import syncapLogo from '@/images/cee-meetup-2026/syncap.svg';
import theMarketerLogo from '@/images/cee-meetup-2026/the_marketer.svg';
import vevolThemesLogo from '@/images/cee-meetup-2026/vevol_themes_logo.webp';
import videoWiseLogo from '@/images/cee-meetup-2026/video_wise.svg';
import xConnectorLogo from '@/images/cee-meetup-2026/x_connectpr.svg';

export const mainAgenda = [
	{ time: '08:00-08:45', title: 'Reception and Check-in: pastries, coffee and tea', type: 'break' },
	{
		time: '09:20-09:35',
		title: 'What 1,000+ CEE Merchants Taught Us About Multichannel Growth',
		speaker: 'Steluta Stici · Key Account Manager, Easy Sales',
	},
	{
		time: '09:40-10:10',
		title: 'Migration to Shopify: From Fragmentation to Unified Execution',
		speaker: 'David Sima · Key Account Executive, Vevol Media',
	},
	{
		time: '10:20-10:35',
		title: 'How a Luxury Bundle Builder Became a Premium Commerce Experience',
		speaker: 'Prakhar Shrivastava · Co-founder, FoxSell Bundles',
	},
	{ time: '10:40-11:10', title: 'The Power of Data in eCommerce and Communication', speaker: 'Rareș Bănescu · Owner & Founder, TheMarketer' },
	{ time: '11:15-11:45', title: 'Networking break: snacks and beverages', type: 'break' },
	{
		time: '11:50-12:20',
		title: 'Decoding the Cart: Consumer Patterns from 50K Eshop-Affiliate Partnerships',
		speaker: 'Ana Opriță · Deputy CEO, BusinessLeague',
	},
	{
		time: '12:25-12:40',
		title: 'The Power of Less: Scaling a Global Brand with 6 People',
		speaker: 'Grace Radley · Senior Country Partnerships Manager, Mollie',
	},
	{
		time: '12:40-12:50',
		title: 'Shopping Simplified: From Cross-border to Borderless',
		speaker: 'Thanasis Psychogios · Sr. Intl. BD Manager, Skroutz',
	},
	{ time: '13:00-14:00', title: 'Lunch break: buffet included', type: 'break' },
	{
		time: '14:00-15:00',
		title: 'Panel: How AI is Transforming Ecommerce & Retention in 2026',
		speaker: [
			'Hosted by Dan Nistor · Co-Founder & CEO, Vevol Media',
			'Bogdan Dogaru · Co-founder & CTO, Vevol Media',
			'Stefan Chiriacescu · Co-founder & CEO, Ecommerce Today',
			'Gabriel Bonciu · Business Development Director, BusinessLeague',
			'Abhishek Chandra · Chief Revenue Officer, Gokwik',
			'Carlotta Zorzi-Chapman · Head of Market Expansion, EMEA, Shopify',
		].join('\n'),
	},
	{
		time: '15:05-15:40',
		title: 'Your customers are on WhatsApp, your competitors are not!',
		speaker: 'Abhishek Chandra · Chief Revenue Officer, Gokwik',
	},
	{
		time: '15:45-16:15',
		title: 'AI-Powered Email Automation: Smarter Journeys. Higher Profits.',
		speaker: 'Paul Apostu · Chief Growth Officer, Ecommerce Today',
	},
	{
		time: '16:20-16:35',
		title: 'Turning Fragmented Omnichannel Retail into Behaviour-Triggered Customer Retention',
		speaker: 'Bogdan Shkarupa · Co-Founder & CEO, NeuCurrent',
	},
	{
		time: '16:40-17:10',
		title: 'Building for CEE: What’s Next on Shopify',
		speaker: 'Carlotta Zorzi-Chapman & Yael Weiss · Shopify',
		type: 'special',
	},
];

export const workshopAgenda = [
	{
		time: '09:00-10:15',
		title: 'Faster Fulfillment, Easier Returns: Shopify Operations',
		speaker: 'Catalin Ciochina · xConnector',
	},
	{
		time: '10:15-11:30',
		title: 'The Complete Shopify Workshop: Setup, Functionality & Optimization with E-commerce Today',
		speaker: 'Andreea Balasa & Diana Matei · E-commerce Today',
	},
	{
		time: '11:30-12:45',
		title: 'More Revenue, Same Traffic: A Step-by-Step Guide to AI Personalization That Converts',
		speaker: 'Tudor Goicea · Aqurate',
	},
	{
		time: '14:00-15:15',
		title: 'From Data to Success: Automated flows that bring results across any eCommerce niche',
		speaker: 'Ilie Mihalache · TheMarketer',
	},
	{
		time: '15:15-16:30',
		title: 'AI-Driven Shopify Strategy and Delivery: Orchestrating Growth',
		speaker: 'Bogdan Dogaru · Vevol Media',
	},
	{
		time: '16:30-17:45',
		title: 'From Clicks to Chats: The Future of Conversational Commerce',
		speaker: 'Connor William Blakey · Head of Partnerships, GoKwik',
	},
];

export const speakers = [
	{
		initials: 'CZ',
		name: 'Carlotta Zorzi-Chapman',
		role: 'Head of Market Expansion, EMEA · Shopify',
		bg: '#276749',
		image: carlottaZorziChapmanImage,
	},
	{ initials: 'YW', name: 'Yael Weiss', role: 'Lead Partner Solutions Engineer · Shopify', bg: '#2c5282', image: yaelWeissImage },
	{ initials: 'R', name: 'Rareș Bănescu', role: 'Founder · TheMarketer', bg: '#2c5282', image: raresBanescuImage },
	{ initials: 'A', name: 'Ana Opriță', role: 'Deputy CEO · BusinessLeague', bg: '#744210', image: anaOpritaImage },
	{ initials: 'P', name: 'Prakhar Shrivastava', role: 'Co-founder · FoxSell Bundles', bg: '#22ffb8', image: prakharShrivastavaImage },
	{ initials: 'G', name: 'Grace Radley', role: 'Sr. Country Partnerships · Mollie', bg: '#276749', image: graceRadleyImage },
	{ initials: 'SS', name: 'Steluta Stici', role: 'Key Account Manager · Easy Sales', bg: '#1a1a1a', image: stelutaSticiImage },
	{ initials: 'T', name: 'Thanasis Psychogios', role: 'Sr. Intl. BD Manager · Skroutz', bg: '#702459', image: thanasisPsychogiosImage },
	{ initials: 'Ab', name: 'Abhishek Chandra', role: 'CRO · Gokwik', bg: '#1a365d', image: abhishekChandraImage },
	{ initials: 'BS', name: 'Bogdan Shkarupa', role: 'Co-Founder & CEO · NeuCurrent', bg: '#1a365d', image: bogdanShkarupaImage },
	{ initials: 'I', name: 'Ilie Mihalache', role: 'Partnership Support · TheMarketer', bg: '#b45309', image: ilieMihalacheImage },
	{ initials: 'Tu', name: 'Tudor Goicea', role: 'Co-founder & CRO · Aqurate', bg: '#1e6091', image: tudorGoiceaImage },
	{ initials: 'Ca', name: 'Catalin Ciochina', role: 'Founder · xConnector', bg: '#6b21a8', image: catalinCiochinaImage },
	{ initials: 'DN', name: 'Dan Nistor', role: 'Co-Founder & CEO · Vevol Media', bg: '#0a6e4a', image: danNistorImage },
	{ initials: 'SC', name: 'Stefan Chiriacescu', role: 'Co-Founder and CEO · Ecommerce Today', bg: '#553c9a', image: stefanChiriacescuImage },
	{ initials: 'B', name: 'Bogdan Dogaru', role: 'Co-Founder & CTO · Vevol Media', bg: '#0a6e4a', image: bogdanDogaruImage },
	{ initials: 'D', name: 'David Sima', role: 'Key Account Executive · Vevol Media', bg: '#5C6AC4', image: davidSimaImage },
	{ initials: 'Pa', name: 'Paul Apostu', role: 'Chief Growth Officer · Ecommerce Today', bg: '#553c9a', image: paulApostuImage },
];

export const expectedItems = [
	'🎤 High-impact talks from top eCommerce leaders across CEE and beyond',
	'🛠 Hands-on workshops with practical takeaways you can use straight away',
	'🤝 Real networking with 250+ merchants, agencies and app developers',
	'🏪 Expo area with booths from top Shopify solution providers — see the tools in action and talk directly to the teams building them',
	'🍽️ Lunch included, because great ideas need fuel',
	'🍸 Afterparty to keep the conversations going after the talks end',
	"⭐ A curated Shopify community experience you'll want to return to every year",
	'🌍 Attendees from across Central & Eastern Europe — merchants, founders, and operators all under one roof',
];

export const carouselLogos = [
	{ name: 'GoKwik', image: gokwikLogo },
	{ name: 'BusinessLeague', image: businessLeagueLogo },
	{ name: 'TheMarketer', image: theMarketerLogo },
	{ name: 'Mollie', image: mollieLogo },
	{ name: 'xConnector', image: xConnectorLogo },
	{ name: 'FoxSell', image: foxSellLogo },
	{ name: 'Easy Sales', image: easySalesLogo },
	{ name: 'Videowise', image: videoWiseLogo },
	{ name: 'Aqurate', image: aquarateLogo },
	{ name: 'Skroutz', image: skroutzLogo },
	{ name: 'Fulfilo', image: fulfiloLogo },
	{ name: 'Axon', image: axonLogo },
	{ name: 'Klever', image: kleverLogo },
	{ name: 'Consentmo' },
	{ name: 'Mejix', image: mejixLogo },
	{ name: 'NeuCurrent', image: neuCurrentLogo },
	{ name: 'Love Loyalty', image: loveLoyaltyLogo },
	{ name: 'DataRevolt', image: dataRevoltLogo },
	{ name: 'Vevol Themes', image: vevolThemesLogo },
	{ name: 'Syncap', image: syncapLogo },
];

export const partnerTiers = [
	{
		key: 'premier',
		label: 'Premier Partners',
		items: [
			{
				name: 'GoKwik',
				url: 'https://www.gokwik.co/uk/product/kwikengage',
				image: gokwikLogo,
				cardStyle: { background: '#fff8e6', borderColor: '#e8c840' },
				pillStyle: { color: '#7a5c00' },
			},
		],
	},
	{
		key: 'plus',
		label: 'Plus Partners',
		items: [
			{
				name: 'BusinessLeague',
				url: 'https://businessleague.com/',
				image: businessLeagueLogo,
				logoColor: 'original',
				logoScale: 3.8,
				cardStyle: { background: '#f0f6ff', borderColor: '#a0c4f5' },
				pillStyle: { color: '#0c447c' },
			},
			{
				name: 'TheMarketer',
				url: 'https://themarketer.com/',
				image: theMarketerLogo,
				logoScale: 3.2,
				logoFilter: 'contrast(2.8) brightness(0.42) saturate(1.2)',
				cardStyle: { background: '#fff0f4', borderColor: '#f5a0bc' },
				pillStyle: { color: '#8b0030' },
			},
			{
				name: 'Mollie',
				url: 'https://www.mollie.com/',
				image: mollieLogo,
				logoScale: 3.3,
				cardStyle: { background: '#f5f0ff', borderColor: '#c4a8f5' },
				pillStyle: { color: '#3b0080' },
			},
			{
				name: 'xConnector',
				url: 'https://about.xconnector.app/',
				image: xConnectorLogo,
				logoScale: 3.4,
				logoFilter: 'contrast(2.8) brightness(0.4) saturate(1.2)',
				cardStyle: { background: '#f0fff8', borderColor: '#a0f0d0' },
				pillStyle: { color: '#0a5e42' },
			},
		],
	},
	{
		key: 'bronze',
		label: 'Bronze Partners',
		items: [
			{
				name: 'FoxSell',
				url: 'https://foxsell.com/',
				image: foxSellLogo,
				logoScale: 3,
				cardStyle: { background: '#fff5e6', borderColor: '#f5c880' },
				pillStyle: { color: '#7a3a00' },
			},
			{
				name: 'Easy Sales',
				url: 'https://easy-sales.com/',
				image: easySalesLogo,
				logoScale: 3.45,
				cardStyle: { background: '#e6fff5', borderColor: '#80f5c8' },
				pillStyle: { color: '#004d30' },
			},
			{
				name: 'Videowise',
				url: 'https://videowise.com/',
				image: videoWiseLogo,
				logoScale: 3,
				cardStyle: { background: '#f0f0ff', borderColor: '#b0b0f5' },
				pillStyle: { color: '#1a1a7a' },
			},
			{
				name: 'Aqurate',
				url: 'https://aqurate.ai/en/',
				image: aquarateLogo,
				logoScale: 3,
				cardStyle: { background: '#e6f8ff', borderColor: '#80d8f5' },
				pillStyle: { color: '#003d5c' },
			},
			{
				name: 'Skroutz',
				url: 'https://www.skroutz.ro/',
				image: skroutzLogo,
				logoScale: 3.2,
				cardStyle: { background: '#fff5e6', borderColor: '#f5a880' },
				pillStyle: { color: '#7a2200' },
			},
			{
				name: 'Fulfilo',
				url: 'https://www.fulfilo.ro/',
				image: fulfiloLogo,
				logoScale: 3.8,
				logoFilter: 'contrast(2.9) brightness(0.38) saturate(1.15)',
				cardStyle: { background: '#f5f5f5', borderColor: '#cccccc' },
				pillStyle: { color: '#333333' },
			},
			{
				name: 'Axon',
				url: 'https://axon.ai/en',
				image: axonLogo,
				logoScale: 3.1,
				cardStyle: { background: '#f0fff0', borderColor: '#90e090' },
				pillStyle: { color: '#1a4d1a' },
			},
			{
				name: 'Klever',
				url: 'https://klever.agency/',
				image: kleverLogo,
				logoScale: 3.15,
				cardStyle: { background: '#fffae6', borderColor: '#f5e080' },
				pillStyle: { color: '#5c4400' },
			},
			{
				name: 'Consentmo',
				url: 'https://www.consentmo.com/',
				cardStyle: { background: '#f0f8ff', borderColor: '#90c8f5' },
				pillStyle: { color: '#003366' },
			},
			{
				name: 'Mejix',
				url: 'https://www.mejix.com/',
				image: mejixLogo,
				logoScale: 3.2,
				cardStyle: { background: '#fff0f8', borderColor: '#f5a0d0' },
				pillStyle: { color: '#6b0040' },
			},
			{
				name: 'NeuCurrent',
				url: 'https://neucurrent.com/',
				image: neuCurrentLogo,
				logoScale: 3.25,
				cardStyle: { background: '#f0f8ff', borderColor: '#90c0f0' },
				pillStyle: { color: '#003366' },
			},
		],
	},
	{
		key: 'partners',
		label: 'Event Partners',
		items: [
			{
				name: 'Love Loyalty',
				url: 'https://www.loveloyalty.app/',
				image: loveLoyaltyLogo,
				logoScale: 3.35,
				logoFilter: 'contrast(2.7) brightness(0.42) saturate(1.2)',
				cardStyle: { background: '#fff0f4', borderColor: '#f5a0bc' },
				pillStyle: { color: '#8b0030' },
			},
			{
				name: 'DataRevolt',
				url: 'https://datarevolt.agency/ro/',
				image: dataRevoltLogo,
				logoScale: 3.25,
				cardStyle: { background: '#f5f0ff', borderColor: '#c4a0f5' },
				pillStyle: { color: '#3b0080' },
			},
			{
				name: 'Vevol Themes',
				url: 'https://vevolthemes.com/',
				image: vevolThemesLogo,
				logoScale: 3.5,
				logoFilter: 'contrast(2.9) brightness(0.36) saturate(1.2)',
				cardStyle: { background: '#f0fffa', borderColor: '#a0f5dc' },
				pillStyle: { color: '#0a5e42' },
			},
		],
	},
];

export const editionsGallerySlots = [
	{ image: lastYearPhotoSeven, className: 'tall' },
	{ image: lastYearPhotoTwo, className: '' },
	{ image: lastYearPhotoThree, className: '' },
	{ image: lastYearPhotoFour, className: 'wide' },
	{ image: lastYearPhotoFive, className: '' },
	{ image: lastYearPhotoSix, className: '' },
	{ image: lastYearPhotoOne, className: '' },
	{ image: lastYearPhotoEight, className: 'wide' },
];

export const editionsStats = [
	{ value: '200+', label: 'Attendees' },
	{ value: '10+', label: 'Speakers' },
	{ value: '8', label: 'Countries represented' },
	{ value: '1', label: 'Unforgettable day' },
];

export const locationPhotos = {
	locationPhotoOne,
	locationPhotoTwo,
	locationPhotoThree,
};
